export default "__VITE_ASSET__BzsZ1gTS__"